import style from './style.module.scss';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useEventsMediaState} from 'modules/events/mediaState/useEventsMediaState';
import {MediaSliderModal} from 'modules/modals/components/MediaSliderModal';
import {RAW_TASTING_IMAGES} from '../contstants';
import React, {useCallback, useMemo, useState} from 'react';
import {hideModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useResize} from 'core/hooks/useResize';
import {getWindowInnerHeight, getWindowInnerWidth} from 'core/helpers';
import Picture from 'components/Picture';

export const TastingSliderModal = () => {
    const [iframeParams, setIframeParams] = useState({
        height: Math.min(getWindowInnerHeight(), 568),
        width: Math.min(getWindowInnerWidth(), 1008),
    });

    const [touchStart, setTouchStart] = useState<number | null>(null);
    const [touchEnd, setTouchEnd] = useState<number | null>(null);

    useResize(() => {
        setIframeParams({
            height: Math.min(getWindowInnerHeight(), 568),
            width: Math.min(getWindowInnerWidth(), 1008),
        });
    });

    const [{mediaSrc, mediaType}, setEventsMediaState] = useEventsMediaState();

    const mediaSrcIndex = useMemo(() => RAW_TASTING_IMAGES.indexOf(String(mediaSrc)), [mediaSrc]);

    const dispatch = useAppDispatch();

    const unmountVideoPlayer = () => setEventsMediaState(() => ({mediaSrc: null, mediaType: null}));

    const onLeftButtonClick = useCallback(() => {
        if (-1 === mediaSrcIndex) {
            return;
        }

        const newIndex = 0 === mediaSrcIndex ? RAW_TASTING_IMAGES.length - 1 : mediaSrcIndex - 1;
        setEventsMediaState((state) => ({
            ...state,
            mediaSrc: RAW_TASTING_IMAGES[newIndex],
            mediaType: 'image',
        }));
    }, [mediaSrcIndex, setEventsMediaState]);

    const onRightButtonClick = useCallback(() => {
        if (-1 === mediaSrcIndex) {
            return;
        }

        const newIndex = mediaSrcIndex === RAW_TASTING_IMAGES.length - 1 ? 0 : mediaSrcIndex + 1;
        setEventsMediaState((state) => ({
            ...state,
            mediaSrc: RAW_TASTING_IMAGES[newIndex],
            mediaType: 'image',
        }));
    }, [mediaSrcIndex, setEventsMediaState]);

    const onCloseModal = () => dispatch(hideModal(MODALS.DEGUSTATION_MEDIA_SLIDER.name));

    const handleTouchStart = useCallback((e: React.TouchEvent) => {
        setTouchStart(e.targetTouches[0].clientX);
    }, []);

    const handleTouchMove = useCallback((e: React.TouchEvent) => {
        setTouchEnd(e.targetTouches[0].clientX);
    }, []);

    const handleTouchEnd = useCallback(() => {
        if (!touchStart || !touchEnd) {
            return;
        }

        const distance = touchStart - touchEnd;
        const minSwipeDistance = 50;

        if (Math.abs(distance) < minSwipeDistance) {
            return;
        }

        if (0 < distance) {
            onRightButtonClick();
        } else {
            onLeftButtonClick();
        }

        setTouchStart(null);
        setTouchEnd(null);
    }, [touchStart, touchEnd, onLeftButtonClick, onRightButtonClick]);

    if ('video' === mediaType) {
        return (
            <MediaSliderModal
                isVideo={true}
                onClose={() => {
                    unmountVideoPlayer();
                    onCloseModal();
                }}
            >
                <iframe
                    width={`${iframeParams.width}px`}
                    height={`${iframeParams.height}px`}
                    src={mediaSrc ?? undefined}
                    frameBorder={'0'}
                    allow={'autoplay'}
                ></iframe>
            </MediaSliderModal>
        );
    }

    return (
        <MediaSliderModal
            isVideo={false}
            onClose={onCloseModal}
            onLeftButtonClick={onLeftButtonClick}
            onRightButtonClick={onRightButtonClick}
        >
            {mediaSrc && (
                <div
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    className={style.pictureWrapper}
                >
                    <Picture src={mediaSrc} className={style.picture} />
                </div>
            )}
        </MediaSliderModal>
    );
};

export default TastingSliderModal;
